import { render, staticRenderFns } from "./TravelCoverage.vue?vue&type=template&id=0233560e&scoped=true&"
import script from "./TravelCoverage.vue?vue&type=script&lang=js&"
export * from "./TravelCoverage.vue?vue&type=script&lang=js&"
import style0 from "./TravelCoverage.vue?vue&type=style&index=0&id=0233560e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0233560e",
  null
  
)

export default component.exports